const baseUrl = 'https://icircles.app'
const getFrontPageUrl = `${baseUrl}/api/cms/pagebasedfrontpage/25`
const siteUrl = `${baseUrl}/microsite`
const barCodeUrl = `${baseUrl}/storage/images/microsites/qr/25.png`
const detailsPostUrl = `${baseUrl}/api/cms/pagebasedpost`


export {baseUrl,barCodeUrl,siteUrl,getFrontPageUrl,detailsPostUrl}

